// import TCPlayer from 'viedo.js';
// import videojs from 'tcplayer.js';
const Button = TCPlayer.getComponent('Button');

class NewButton1 extends Button {
  constructor(player, options) {
    super(player, options);
    this.controlText('-15s');
    this.addClass('vjs-pan-tilt-control-button');

    // 设置按钮图标
    const iconSpan = document.createElement('span');
    iconSpan.className = 'custom-icon';
    iconSpan.innerHTML = '◀◀'; // 使用emoji图标
    this.el().appendChild(iconSpan);
  }

  handleClick() {
    // 在这里添加按钮点击后的逻辑
    // console.log('Pan/Tilt button clicked');
    const player = this.player();
    // 获取当前播放时间
    const currentTime = player.currentTime() || 0;
    // 后退15秒，不能小于0
    player.currentTime(Math.max(currentTime - 15, 0));
    // 例如，触发一个自定义事件
    this.player().trigger('panTiltControl');
  }
}
class NewButton2 extends Button {
  constructor(player, options) {
    super(player, options);
    this.controlText('+15s');
    this.addClass('vjs-pan-tilt-control-button');

    // 设置按钮图标
    const iconSpan = document.createElement('span');
    iconSpan.className = 'custom-icon';
    iconSpan.innerHTML = '▶▶'; // 使用emoji图标
    this.el().appendChild(iconSpan);
  }

  handleClick() {
    // 在这里添加按钮点击后的逻辑
    // console.log('Pan/Tilt button clicked');
    // var player = videojs('my-video');
    const player = this.player();
    // 获取当前播放时间
    const currentTime = player.currentTime() || 0;
    const duration = player.duration && player.duration();
    const targetTime = currentTime + 15;
    // 快进15秒，不能超过总时长
    player.currentTime(duration ? Math.min(targetTime, duration) : targetTime);

    // 例如，触发一个自定义事件
    this.player().trigger('panTiltControl2');
  }
}

// 注册组件
TCPlayer.registerComponent('NewButton1', NewButton1);
TCPlayer.registerComponent('NewButton2', NewButton2);
